// This file is automatically generated. Do not edit it directly.
// Using singleton instance from lib/supabase to avoid multiple GoTrueClient instances
import { supabase as supabaseInstance } from '@/lib/supabase';
import type { Database } from './types';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = supabaseInstance;